import React, { PureComponent } from 'react';
import getTimeDifference from '../../utils/getTimeDifference';

class Countdown extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loadedWithin5Minutes: false,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };

    this.tickTimer = this.tickTimer.bind(this);
  }

  componentDidMount() {
    const { cutOffTime } = this.props;

    const cutOffTimeDate = new Date();
    cutOffTimeDate.setHours(cutOffTime, 0, 0);

    const timeNow = new Date();
    const { hours, minutes, seconds } = getTimeDifference(cutOffTimeDate, timeNow);

    const loadedWithin5Minutes = !hours && minutes <= 5;

    this.setState({
      loadedWithin5Minutes,
      hours,
      minutes,
      seconds: seconds > 60 ? 60 : seconds,
    });

    const currentSeconds = timeNow.getSeconds();
    const secondsTillNextMinute = minutes === 1 ? 0 : 1000 * (60 - currentSeconds);

    this.initialTimeout = setTimeout(() => {
      this.tickInterval = setInterval(this.tickTimer, 1000 * 60);

      this.tickTimer();
    }, secondsTillNextMinute);
  }

  componentWillUnmount() {
    clearTimeout(this.initialTimeout);
    clearInterval(this.tickInterval);
    clearInterval(this.secondInterval);
  }

  tickTimer() {
    const { hours, minutes, seconds } = this.state;
    let newHours = hours;
    let newMinutes = minutes;
    let newSeconds = seconds;

    if (minutes === 0) {
      newHours -= 1;
      newMinutes = 59;
    } else {
      newMinutes -= 1;
    }

    if (newHours === 0 && newMinutes === 1) {
      clearInterval(this.tickInterval);

      this.secondInterval = setInterval(() => {
        this.setState(state => {
          if (state.seconds === 1) {
            clearInterval(this.secondInterval);

            return { hours: 0, minutes: 0, seconds: 0 };
          }

          return {seconds: state.seconds - 1}
        });
      }, 1000);
    }

    this.setState({ hours: newHours, minutes: newMinutes, seconds: newSeconds });
  }

  render() {
    const { loadedWithin5Minutes, hours, minutes, seconds } = this.state;
    const hoursBeforeCutOff = 3;

    if (
      loadedWithin5Minutes ||
      hours < 0 ||
      hours === 0 && minutes === 0 && seconds === 0 ||
      hours > hoursBeforeCutOff ||
      (hours === hoursBeforeCutOff && minutes > 0)
    ) {
      return null;
    }
    const { collectTime } = this.props;
    return (
      <div className="click-and-collect-countdown">
        <span>
          Order in the next
          <span className="click-and-collect-countdown__time">
            {hours ? ` ${hours} hour${hours > 1 ? 's' : ''} ` : ''}
            {minutes && minutes !== 1 ? ` ${minutes} minutes ` : ''}
            {minutes === 1 ? ` ${seconds} second${seconds > 1 ? 's' : ''} ` : ''}
          </span>
          to collect in-store from {collectTime || '3pm'} tomorrow
        </span>
      </div>
    );
  }
}

export default Countdown;
